import Big from "big.js";

/**
 * @typedef {string | number | Big} BigValue
 */

/**
 * 덧셈
 * @param {BigValue} left
 * @param {BigValue} right
 * @returns {string}
 */
export const add = (left, right) => {
  return Big(left).plus(right).toString();
};

/**
 * 뺄셈
 * @param {BigValue} left
 * @param {BigValue} right
 * @returns {string}
 */
export const subtract = (left, right) => {
  return Big(left).minus(right).toString();
};

/**
 * 곱셈
 * @param {BigValue} left
 * @param {BigValue} right
 * @returns {string}
 */
export const multiply = (left, right) => {
  return Big(left).times(right).toString();
};

/**
 * 나눗셈
 * @param {BigValue} left
 * @param {BigValue} right
 * @returns {string}
 */
export const divide = (left, right) => {
  return Big(left).div(right).toString();
};
